export default __webpack_public_path__ + "static/media/dollar.7431e76d.png";